export const announcementsSelector = state => state.dashboard.get('announcements')

export const upcomingCallsSelector = state => state.dashboard.get('summary')

export const dashboardSelector = state => state.dashboard.toJS()

export const upcomingCallSelector = state => state.dashboard.get('upcomingCall', null)?.toJS()
